import { getPlayersByPlayerExternalIdOptions } from "@aura-frontend/omnibus-az-client";
import { useQueries } from "@tanstack/react-query";

export const usePlayersByExternalIds = (externalIds: string[] | undefined) => {
  const queries = useQueries({
    queries:
      externalIds?.map((id) => ({
        ...getPlayersByPlayerExternalIdOptions({
          path: { player_external_id: encodeURIComponent(id) },
          query: {},
        }),
        enabled: !!id,
        retry: false,
      })) ?? [],
  });

  const isLoading = queries.some((q) => q.isLoading);
  const players = queries.map((q) => q.data).filter((p) => p !== undefined);

  return { isLoading, players };
};
